import styled from 'styled-components';

export const StyledButtonContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
`;

export const StyledTitleContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: left;
    color: ${(p) => p.theme.colors.loopEmerald};
    margin: 5px 0px;
    font-size: ${(p) => p.theme.fontSizes.title};
    font-weight: 100;
    width: 90%;
    margin-right: auto;
    line-height: 36px;
    letter-spacing: 0.02em;
`;

export const StyledSubTitle = styled.span`
    color: ${(p) => p.theme.colors.loopEmerald};
    margin: 50px 0px;
    font-size: ${(p) => p.theme.fontSizes.label};
    font-style: normal;
    font-weight: 100;
    font-size: 20px;
    width: 100%;
`;

export const UserNotRegisteredButton = styled.div(
    (p) => `
    color: ${p.theme.colors.loopEmerald};
    font-size: ${p.theme.fontSizes.body};
    border: 1px solid ${p.theme.colors.primary};
    font-weight: 700;
    min-width: 150px;
    cursor: pointer;
    width:100%;
    padding: 18px 0px;
    border-radius: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
        font-style: normal;
    font-weight: 500;
    @media (max-width: 768px) {
        margin-right: 0px;
        width: 70%;
    }
`
);
export const UserRegisteredButton = styled.div(
    (p) => `
    color: ${p.theme.colors.loopEmerald};
    font-size: ${p.theme.fontSizes.body};
    background-color: ${p.theme.colors.coverUpGreen};
    font-weight: 700;
    border-radius: 16px;
    min-width: 150px;
    width:100%;
    margin-bottom:20px;
    cursor: pointer;
    padding: 18px 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-style: normal;
    font-weight: 500;
    font-family:'Work Sans';
    @media (max-width: 768px) {
        margin-top: 15px;
        width: 70%;
    }
`
);
export const StyledContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
`;
